import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DetalhesLotesManualV2Component } from './../detalhes-lotes-manual-v2/detalhes-lotes-manual-v2.component';
import { LotesRepasseComponent } from './lotes-repasse.component';

const routes: Routes = [
  {
    path: 'detalhes-lote-manual-v2/:id',
    component: DetalhesLotesManualV2Component,
    title: 'Lote Repasse'
  },
  {
    path: '',
    component: LotesRepasseComponent,
    title: 'Repasse de Comissão',
    children: [{ path: ':mode', redirectTo: '', pathMatch: 'full' }, ]
  },
  {
    // Rota legada (Type='Automatic', nunca usada em producao — confirmado no
    // banco, 2026-08-28). Redireciona em vez de apagar, pra links/favoritos
    // antigos continuarem funcionando, so que sempre na tela v2.
    path: 'detalhes-lote/:id',
    redirectTo: 'detalhes-lote-manual-v2/:id',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LotesRepasseRoutingModule {}
